import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { Container, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import '../../styles/modifySession.scss';

import { getCookie } from "../../data/Cookies";

import axios from 'axios';
import { FormProvider, SubmitHandler, useForm, useWatch } from 'react-hook-form';
import useUserData from '../../hooks/useUserData';

import * as Types from "../../App";
import { SessionType } from '../../App';
import { ChargingMode } from '../../data/models/ChargingMode';
import UserProfile from '../../data/models/UserProfile';
import { BottomNavigation, BottomNavigationAction, Button, IconButton } from '@mui/material';
import { BsClockHistory, BsFillLightningChargeFill, BsTrophy } from 'react-icons/bs';
import NavigationBar from '../widgets/NavigationBar';
import TimeInput from '../widgets/TimeInput';
import { GlobalButton } from '../styled/Button';
import { MdArrowBack } from 'react-icons/md';

interface ScheduleProps {
    settings: Types.SessionType,
    setSettings: (values: Types.SessionType) => void,
}


/**
 * ModifySession component of the web application. 
 */
export default function ModifySession() {
    const history = useHistory();

    // Retrieve info from server
    const { userData, getUserData } = useUserData();
    let id = getCookie("id");

    useEffect(() => {
        getUserData(id);
    }, [id])

    const initialValues = {
        arrival: new Date(),
        departure: new Date(),
        finished: new Date(),
        isAborted: false,
        mode: null,
        price: 0,
        CO2: 0,
        desiredEnergy: 0,
        actualEnergy: 0,
        planning: null,
    }

    const form = useForm({
        defaultValues: initialValues, //{...initialValues},
    });


    // Delay departure time
    function delayDeparture() {
        //waiting for API endpoint
        console.log(userData.session_hours + " " + userData.session_minutes);
    }

    function handleClick(ButtonType) {
        history.push("/session")
    }

    // Default value of pop-up.
    const [modal, setModal] = useState(false);

    // TODO: Move this to ChargingSession
    // The user confirms the abortion of the session.
    const cancelCahrging = useCallback(() => {
        // Modal is set to default value.
        setModal(!modal);

        //Send cancelation to the backend
        axios.post('https://slimpark.roaming.utwente.nl:3001/cancel', {
            "cancelation": true,
            "id": getCookie("id"),
        })
            .then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });

        // user goes back to the login page
        history.push("/");
    }, [history]);

    //The user cancels the abortion and remains on ChargingSession page.
    const continueCharging = useCallback(() => setModal(!modal), [modal, setModal]);

    function navigate(pageNumber) {
        if (pageNumber === 0) {
            history.push("/statistics");
        } else if (pageNumber === 1) {
            history.push("/");
        } else if (pageNumber === 2) {
            history.push("/history");
        }
    }

    return (
        <Container className="modifySession">
            <Row>
                <Col>
                    <FormProvider {...form}>
                        <h1>New departure time:</h1>
                        <TimeInput />
                    </FormProvider>
                </Col>
            </Row>
            <Row style={{alignItems: 'baseline'}}>
                <Col>
                    <GlobalButton onClick={handleClick} text="Go Back" />
                </Col>
                <Col>
                    <Button variant='outlined' color='success' onClick={delayDeparture} disabled
                        sx={{
                            borderRadius: '15px',
                            textTransform: 'none',
                            fontWeight: '800',
                            fontFamily: 'Open Sans',
                            border: '1px solid',
                        }}>Update departure time</Button>
                </Col>
            </Row>
            <Row>
            </Row>
            <NavigationBar />
        </Container>
    );
}